import type { RouteRecordRaw } from 'vue-router';

import { RouteNames } from '@/router/constants/routeName';

const errorRoutes: RouteRecordRaw[] = [
  {
    path: '/error',
    name: RouteNames.Error,
    component: () => import('@/views/ErrorView.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/access-denied',
    name: RouteNames.AccessDenied,
    component: () => import('@/views/AccessDeniedView.vue'),
  },
];

export default errorRoutes;
